import actionTypes from '../constants/actionTypes'
import { /*setLocalTime, */ updateCommentary, updateVideos, filterVideoContent, filterCommentaryVideos, filterScorecardVideos, filterActivePlayerVideos, filterBet365, updateArticle, updateGameStrip, checkLastEndOfOver } from './helpers'
import selectn from 'selectn'

export default function gamePackageReducer(state = {}, action) {
  var copyRightCheckObj = {}
  copyRightCheckObj.site    = selectn('edition.site', action) || ''
  copyRightCheckObj.domain  = selectn('edition.domain', action) || ''
  copyRightCheckObj.userGeo = selectn('edition.userGeo', action) || ''
  copyRightCheckObj.isWebView = selectn('params.webview', action) || ''

  switch(action.type) {
    case actionTypes.GET_RENDERED_ARTICLE:
    case actionTypes.GET_GAMEPACKAGE:
      var { article = {}, allVideos, partCommentary, scorecard, innings = {}, bet365, ...rest } = action.data

      var prevVideos = selectn('allVideos.videos', state) || []
      var video = []
      var pageType = selectn('params.pageType', action)
      var country = (selectn('edition.userGeo', action) || '').toUpperCase()
      var isFastcast = action.isFastcast || false
      var commFilterPrev = selectn('selCmtryFilter.playtype', state)
      var commInningsPrev = selectn('selInnings.period', state) || 1
      var commFilter = selectn('data.selCmtryFilter.playtype', action)
      var commInnings = selectn('data.selInnings.period', action) || 1

      // reinit fullcommentary state if innings/commentary-filter is changed
      if (action.type === actionTypes.GET_GAMEPACKAGE) {
        if (!commInningsPrev || !commFilterPrev) {
          rest.fullCommentary = { init : true }
        } else if (commInningsPrev !== commInnings || commFilterPrev !== commFilter) {
          rest.fullCommentary = { init : true, commSwitch: true }
        }
      }
      if (prevVideos.length <= 20) {
        rest.allVideos = allVideos
      } else {
        rest.allVideos = state.allVideos
      }

      article = updateArticle(state.article, article, pageType, isFastcast)

      video = selectn('article.video', state) || []
      filterVideoContent(rest, country, copyRightCheckObj)
      filterScorecardVideos(scorecard, country, copyRightCheckObj)
      filterActivePlayerVideos(innings, country, copyRightCheckObj)
      filterVideoContent(video, country, copyRightCheckObj)
      filterCommentaryVideos(partCommentary, country, copyRightCheckObj)
      if(typeof bet365 === 'undefined') {
        bet365 = selectn('bet365', state) || {}
      }
      if ('cricket' === selectn('params.sport', action)) {
        filterBet365(bet365, country)
      }

      article.video = video
      checkLastEndOfOver(partCommentary, false)

      return Object.assign({}, state, {
        article,
        commentaryFeedback : {},
        country,
        partCommentary,
        scorecard,
        innings,
        bet365,
        ...rest,
        clientApiUrl: action.clientApiUrl || state.clientApiUrl
      })

    case actionTypes.GET_PLAY_BY_PLAY:
      filterCommentaryVideos(action.data.fullCommentary, state.country, copyRightCheckObj)
      return updateCommentary(state, action.data, action.isPolling, copyRightCheckObj)

    case actionTypes.GET_VIDEOS_MORE:
      return updateVideos(state, action.data, copyRightCheckObj)

    case actionTypes.API_REQUEST_START:
      return Object.assign({}, state, {
        loading: action.isPolling ? false : true
      })

    case actionTypes.HISTORY_CHANGE:
    case actionTypes.API_REQUEST_COMPLETE:
      return Object.assign({}, state, {
        loading: false
      })

    case actionTypes.COMM_FB_STATUS:
      var status = action.status
      var { commentaryFeedback = {} } = state

      commentaryFeedback = Object.assign({}, commentaryFeedback, {
        status : { [status]: true }
      })

      return Object.assign({}, state, { commentaryFeedback })
    case actionTypes.UPDATE_GAMESTRIP_TIME:
      if(state.gameState && state.gameState === 'pregame' ) {
        var isoDate = selectn('gameStrip.isoDate', state)
        var timeValid = selectn('gameStrip.timeValid', state)
        var dateObj = updateGameStrip(isoDate, action.sport, timeValid)
        state.gameStrip.date = dateObj.date
        state.gameStrip.time = dateObj.time
      }
      return Object.assign({}, state)

    case actionTypes.RESET_GAMEPACKAGE:
      return {}

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ../app/reducers/gamePackage.js